import React, { useEffect, useState } from "react";
import { Instagram, ExternalLink } from "lucide-react";
import api from "@/lib/api";

export default function SocialWall() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/social").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section className="py-24" data-testid="social-wall">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <p className="overline mb-3"><Instagram size={12} className="inline mr-1.5" /> Follow The Journey</p>
            <h2 className="font-display text-4xl md:text-5xl font-light text-white tracking-tight">
              @prophetofluv
            </h2>
            <p className="text-white/60 mt-3 max-w-lg">The DaviDÉ world, one frame at a time.</p>
          </div>
          <a href="https://www.instagram.com/prophetofluv" target="_blank" rel="noopener noreferrer"
            data-testid="social-wall-follow-btn"
            className="btn-outline-gold inline-flex items-center gap-2">
            <Instagram size={14} /> Follow on Instagram
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 md:gap-3">
          {posts.slice(0, 6).map((p, i) => (
            <a key={p.id} href={p.link_url || "https://www.instagram.com/prophetofluv"}
              target="_blank" rel="noopener noreferrer"
              data-testid={`social-post-${i}`}
              className="group relative block aspect-square overflow-hidden bg-[#141414]">
              <img src={p.image_url} alt={p.caption || "DaviDÉ"}
                className="w-full h-full object-cover transition-all duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-colors flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity text-[var(--davide-gold)] flex flex-col items-center gap-1">
                  <ExternalLink size={20} />
                  {p.caption && <span className="text-[10px] uppercase tracking-widest">{p.caption}</span>}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
